import { CLEANER_REGIONS } from '~constants/region';
import i18n from '@/i18n';

export default {
  data() {
    return {
      useNullableRegion: true,
    };
  },
  computed: {
    cleanerRegionsItems() {
      const items = [];
      if (this.useNullableRegion) {
        items.push({
          text: i18n.t('global.filter.statuses.all'),
          value: null,
        });
      }
      Object.keys(CLEANER_REGIONS)
        .forEach(key => {
          if (key === 'defaultRegionText') {
            return true;
          }
          items.push({
            text: i18n.t(`global.filter.regions.${CLEANER_REGIONS[key]}`),
            value: CLEANER_REGIONS[key],
          });
        });
      return items;
    },
  },
};
